import React, {
  useEffect,
  useState,
  useRef,
} from 'react';

import { useDispatch, connect } from 'react-redux';

import { withRouter } from "react-router-dom";

import {
  BusinessLogo,
  ControlContainer,
  LoginContainer,
  RememberMeLabel,
  RegisterHyperlink,
  RegisterText,
  RememberMeCheckBox,
  RememberMeContainer,
  RememberMeIcon,
  RememberMeText,
} from './LoginLayout.styled'

import { PrimaryButton } from '../input/TextField.styles'
import { TextField } from '../input';
import Loader from '../../../components/common/Loader';
import Error from '../../../../src/components/error/Error';

import businessLogo from '../../../images/login-business-logo.svg';

import * as Tagging from '../../../tagging/LoginFormTagging';
import * as Constants from '../../../components/common/Constants';
import HOCLogger from '../../../../src/components/common/HOCLogger';
import * as OtpTagging from '../../../tagging/OtpFormTagging';
import AuthService from '../../../services/AuthService';
import ContactService from '../../../services/ContactService';
import ProfileService from '../../../services/ProfileService';
import { OtpPopUp } from '../OtpPopUp/OtpPopUp';
import OtpAuthService from '../../../services/OtpAuthService';
import { ErrorPage } from '../errorPage/ErrorPage';
import * as ErrorTagging from '../../../tagging/ErrorTagging'

const ERROR_MESSAGE = {
    TECHNICAL_ERROR : 'We’re experiencing technical difficulties. Please try again later.',
    UNABLE_TO_GENERATE_OTP : 'We are unable to generate an OTP. Please try again later.',
    ENTERED_INCORRECT_OTP_3_TIMES : 'You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.',
    TEMPORARILY_BLOCK_USER : 'For your security, you’ve been temporarily blocked from requesting new OTPs. Please try again in 24 hours.'
};

export const LoginLayout = (props) => {

  const [ showLoader, setShowLoader ] = useState(false);
  const [rememberme, setRememberme] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passDisplayValue, setPassDisplayValue] = useState('');
  const [loginsuccess, setLoginsuccess] = useState(false);
  const [isValidUsername, setIsValidUsername] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [displayPage, setDisplayPage] = useState(Constants.LOGIN);
  const [showPassword, setShowPassword] = useState(false);
  const [usernameActive, setUsernameActive] = useState(false);
  const [inputpasswordActive, setInputpasswordActive] = useState(false);
  const [fieldActive, setFieldActive] = useState({});
  const [ showOtpPopUp, setShowOtpPopUP ] = useState(false);
  const [ viewPopup, setViewPopup ] = useState('none');
  const [ otpCode, setOTPCode ] = useState("");
  const [ isPinReady, setIsPinReady ] = useState(false);
  const [ otpSentTo, setOtpSentto ] = useState('');
  const [ otpReady, setOtpReady ] = useState(false);
  const [ wrongOtpCount, setWrongOtpCount ] = useState(0);
  const [ isError, setIsError ] = useState();
  const [ errorMessage, setErrorMessage ] = useState([]);
  const [ otpResendMessage, setOtpResendMessage ] = useState({});
  const [ snackBarDisplay, setSnackBarDisplay ] = useState('none');
  const [ notificationAlertDisplay, setNotificationAlertDisplay ] = useState('');
  const [ notificationAlertMessage, setNotificationAlertMessage ] = useState('');
  const [ isWrongUsrNamePasswrd, setIsWrongUsrNamePasswrd ] = useState(false)
  const [ disableLogin, setDisableLogin ] = useState(false);
  const [resetComponent, setResetComponent] = useState(false);
  const prevPasswordRef = useRef('');
  const dispatch = useDispatch();
  const [ disableField, setDisableField ] = useState(false);

  const setPageToBeDisplayed = (page) => {
    if (page === Constants.REGISTER) {
      Tagging.registerClickEvent();
    }
    
    dispatch({ type: Constants.SET_PAGE_TOBE_DISPLAYED, payload: page });
  };

  const onLoginSuccess = (username) => {
    dispatch({ type: Constants.LOGIN_SUCCESS, username: username })}

  const setGSMAccess = (value) => {
    dispatch({ type: Constants.SET_GSM_ACCESS, value: value });
  };

  const setContextDetails = (response) => {
    dispatch({
      type: Constants.SET_CONTEXT_DETAIL,
      payload: response
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const setMsisdnNumber = (number) => {
    dispatch({ type: Constants.OTP_MSISDN, otpmsisdn: number });
  };

  useEffect(() => {
    Tagging.loginPageLoad();
  },[]);

  useEffect(() => {
    changeDisplay();
    showCloseBtn();

    if (resetComponent) {
      clearInputFields();
      setResetComponent(false);
    }
  }, [resetComponent]);

  useEffect(() => {
    setResetComponent(true);
  }, [props.pageToBeDisplayed]);

  useEffect(() => {
    if (viewPopup === 'flex') {
      setDisableField(true);
      setDisableLogin(false);
    } else {
      setDisableLogin(validateLogin());
      setDisableField(false)
    }
  }, [viewPopup])

  const setUserOnRememberMe = () => {

    let username = "";
    const loginUserCookie = document.cookie.toString();
    if (loginUserCookie.indexOf("loginCookie=") > -1 && loginUserCookie.indexOf(";") > -1) {
      const tempUsername = loginUserCookie.substring(loginUserCookie.indexOf("loginCookie=") + 12);
      if (tempUsername.indexOf(";") === -1) {
        username = tempUsername;
      } else { username = tempUsername.substring(0, tempUsername.indexOf(";")); }
    } else if (loginUserCookie.indexOf("loginCookie=") > -1) {
      username = loginUserCookie.
      substring(loginUserCookie.indexOf("loginCookie=") + 12, loginUserCookie.length);
    }
    setUsername(username);
    setUsernameActive(username !== '');
    setRememberme(username !== '');
    setIsValidUsername(username !== '');
  }

  const clearInputFields = () => {
    setUserOnRememberMe();
    setPassword('');
    setPassDisplayValue('');
    setIsValidPassword(false);
    setShowPassword(false);
    setInputpasswordActive(false);
    setFieldActive({});
  };

  useEffect(() => {

    setUserOnRememberMe();
  }, []);

  useEffect(() => {
    if (prevPasswordRef.current === '' && password !== '') {
      setInputpasswordActive(true);
    }
    prevPasswordRef.current = password;
  }, [password]);


  const showCloseBtn = () => {
    props.showCloseBtn(true);
  }

  const callForgotUsername = () => {
      Tagging.forgotClickEvent('Username');
      setPageToBeDisplayed(Constants.FORGET_USERNAME);
  };

  const callForgotPassword = () => {
      Tagging.forgotClickEvent('Password');
      setPageToBeDisplayed(Constants.FORGET_PASSWORD);
  };

  const validateLogin = () => {
    return (username !== '' && username.length >= 1 && password !== '' && password.length > 3);
  }

  useEffect(() => {
    setDisableLogin(validateLogin());
  }, [username, password]);

  const resetPage = () => {
    setUserOnRememberMe();
    setPassword('');
    setWrongOtpCount(0);
    setDisableLogin(false);
    setIsWrongUsrNamePasswrd(false);
    props.setNotificationAlertDisplay('none');
  }

  const onChange = (e) => {
    let value = e.target.value
    setIsWrongUsrNamePasswrd(false);
    switch (e.target.id) {
      case "Username":
        setUsername(value);
      break;
      case "Password":
        setPassword(value);
      break;
      default: break;
    }
  }

  const redirectToErrorPage = (heading, message1, message2) => {
    setIsError(true);
    setErrorMessage({heading: heading, messageLine1: message1, messageLine2: message2})
  }

  const showNotificationPopup = (show, message) => {
    props.setNotificationAlertDisplay(show ? 'flex' : 'none');
    props.setNotificationText(message);
  }

  const resendOtp = () => {
    props.showLoader(true);
    setWrongOtpCount(0);
    setOTPCode('');
    setOtpResendMessage({line1: "Your One-Time PIN has been resent.", line2: "Please check your inbox."});
    OtpTagging.resendOTP();
    showNotificationPopup(false, '');
    ProfileService.generateOTP(username)
        .then((response) => {
          props.showLoader(false);
            if (response.status === 400 || response.status === 404) {
                Constants.removeCookie(Constants.AUTH_TOKEN);
            }
            if (response.status === 200) {
              OtpTagging.generateOTP();
                if (response.data.result.message) {
                    setSnackBarDisplay('flex');
                    OtpTagging.OTPsuccefullyResent();

                    setInterval(()=>{
                        setSnackBarDisplay('none');
                    },9000)
                }
            }
        }).catch((error) => {
            props.showLoader(false);
            Constants.removeCookie(Constants.AUTH_TOKEN);
            showNotificationPopup(true, ERROR_MESSAGE.UNABLE_TO_GENERATE_OTP);
            OtpTagging.generateOTPError('We are unable to generate an OTP.', 'Please try again later.');
          });
  }
  
  const callOnSubmit = (e) => {
    e.preventDefault();
    props.setNotificationAlertDisplay('none');
    Tagging.loginClickEvent(username);
    const encryptedPassword = Constants.encryptStr(password);
    setContextDetails({});
    localStorage.setItem("_masterAccount", "");
    props.showLoader(true);

    AuthService.authenticateUser(username, encryptedPassword.toString()).then((res) => {
      setLoginsuccess(res.data.result.result);

        if (res.data.result.result === true) {
            if (res.data.result.redirect === 'dashboard') {
              ContactService.getContextUserInformation(username)
                .then((response) => { 
                  if (response.status === 200) {
                      const data = {
                        "userName": response.data.result.userName,
                        "email": response.data.result.email,
                        "cellNumber": response.data.result.cellNumber,
                        "contactID": response.data.result.contactID,
                        "firstName": response.data.result.firstName,
                        "lastName": response.data.result.lastName,
                        "msLoginUrl": response.data.result.redirect
                      };
                      onLoginSuccess(username);
                      setContextDetails(data);

                      ProfileService.getGsmAccessStatus(data.contactID)
                        .then((response) => {
                          props.showLoader(false);


                          setGSMAccess(response.data.result);
                          
                          if (response.data.result) {
                            Constants.redirectToDashboard();
                          } else {
                            Constants.redirectToFixProducts();
                          }
                        }).catch((error) => {
                          props.showLoader(false);

                          setGSMAccess(false);
                          Constants.redirectToFixProducts();
                        })
                  }
                }).catch((error) => {
                  scrollToTop();
                  props.showLoader(false);
                  showNotificationPopup(true, ERROR_MESSAGE.TECHNICAL_ERROR);
                  setContextDetails({});
                });
              } else {
                ProfileService.generateOTP(username)
                  .then((response) => {
                    if (response.status === 200) {
                      const message = response.data.result.message;
                      setOtpSentto(message.substring(message.indexOf("+"), message.length).split('and'));
                      setShowOtpPopUP(true);
                      OtpTagging.pageLoadOTP();
                      setViewPopup('flex');
                      onLoginSuccess(username);
                      if (response.data.result.message) {
                        setMsisdnNumber(response.data.result.message.substring((response.data.result.message.indexOf(":") + 1), response.data.result.message.length));
                        props.showLoader(false);
                      }
                    }
                }).catch((err) => {
                  Constants.removeCookie(Constants.AUTH_TOKEN);
                  props.showLoader(false);
                  if (err &&
                      err.response &&
                      err.response.data &&
                      err.response.data.messages
                    ) {
                        if (err.response.data.messages[0].message === ERROR_MESSAGE.ENTERED_INCORRECT_OTP_3_TIMES) {
                          resetPage();
                          redirectToErrorPage('You’ve entered 3 invalid OTPs', ERROR_MESSAGE.TEMPORARILY_BLOCK_USER, '');
                        } else {
                          props.showLoader(false);
                          showNotificationPopup(true, ERROR_MESSAGE.UNABLE_TO_GENERATE_OTP);
                        }
                      }
                    }
                  );
              }
              if (rememberme === true) {
                const d = new Date();
                d.setTime(d.getTime() + (10 * 24 * 60 * 60 * 1000));
                const expires = "expires=" + d.toUTCString();
                document.cookie = "loginCookie=" + username + "; " + expires;
              } else {
                  document.cookie = "loginCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
              }
            }
          }).catch((error) => {
            props.showLoader(false);

            if (error.response.status === 401) {
              setDisableLogin(false);
              setIsWrongUsrNamePasswrd(true);
              Tagging.credentialsErrorEvent("Username & password do not match");
            } else {
              scrollToTop();
              showNotificationPopup(true, ERROR_MESSAGE.TECHNICAL_ERROR);
              ErrorTagging.loginTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR);
            }
      });
  };
  useEffect(() => {

    if(otpCode && otpReady) {
      setOtpReady(true);
    }
  }, [otpCode, otpReady])

  const validateOtp = (e) => {
    showNotificationPopup(false, '');
    OtpTagging.submitOTP();
    e.preventDefault();
    const authToken= Constants.getAuthToken(Constants.AUTH_TOKEN);
    props.showLoader(true);
    const encryptedPassword = Constants.encryptStr(password);
    OtpAuthService.validateOTP(username, encryptedPassword.toString(), otpCode, authToken)
      .then((response) => {
        if (response.status === 200) {
          ContactService.getContextUserInformation(username)
          .then((response) => {
            if (response.status === 200) {
              const data = {
                "userName": response.data.result.userName,
                "email": response.data.result.email,
                "cellNumber": response.data.result.cellNumber,
                "contactID": response.data.result.contactID,
                "firstName": response.data.result.firstName,
                "lastName": response.data.result.lastName,
                "msLoginUrl": response.data.result.redirect
              };

              setContextDetails(data);

              ProfileService.getGsmAccessStatus(data.contactID)
                  .then((response) => {

                    setGSMAccess(response.data.result);
                    
                    if (response.data.result) {
                      Constants.redirectToDashboard();
                    } else {
                      Constants.redirectToFixProducts();
                    }
                  }).catch((error) => {
                  setGSMAccess(false);
                  Constants.redirectToFixProducts();
              })
            }
          }).catch((error) => {
            props.showLoader(false);
            showNotificationPopup(true, ERROR_MESSAGE.TECHNICAL_ERROR);
            ErrorTagging.loginTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR);
            this.props.setContextDetails({});
          });
        }
      }).catch((err) => {
          props.showLoader(false);
          if (err && err.response && !err.response.status === 400) {
              Constants.removeCookie(Constants.AUTH_TOKEN);
          }
          
          if (err && err.response && err.response.data && err.response.data.messages) {
            if (err.response.data.messages[0].message === "Your OTP has expired. Please request a new OTP.") {
              scrollToTop();
              props.showLoader(false);
              showNotificationPopup(true, 'Your OTP has expired. Please try again later. Please request a new OTP.');
            
            } else if (err.response.data.messages[0].message === "You have entered incorrect OTP. Please try again.") {
              if (wrongOtpCount === 0)
                {
                  scrollToTop();
                  showNotificationPopup(true, 'Looks like you entered an invalid OTP. Please try again.');
                  OtpTagging.invalidOtpEntered('Looks like you entered an invalid OTP again', 'You have one attempt remaining', 'Please try again.');
                  setWrongOtpCount(wrongOtpCount+1);
                } else if (wrongOtpCount === 1)
                {
                  scrollToTop();
                  showNotificationPopup(true, 'Looks like you’ve entered an invalid OTP again. You have one attempt remaining. Please try again.');
                  OtpTagging.secondInvalidOtpEntered('Looks like you’ve entered an invalid OTP again. You have one attempt remaining. Please try again.');
                  setWrongOtpCount(wrongOtpCount+1);
                } else {
                  resetPage();
                  redirectToErrorPage('You’ve entered 3 invalid OTPs', ERROR_MESSAGE.TEMPORARILY_BLOCK_USER,'');
                  OtpTagging.lastInvalidOtpEntered("You’ve entered 3 invalid OTPs","For your security, you’ve been temporarily blocked from requesting new OTPs.", "Please try again after 24 hours.");
                  Constants.removeCookie(Constants.AUTH_TOKEN);
                  setViewPopup('none');
                  setShowOtpPopUP(false);
                }

              } else if (err.response.data.messages[0].message === ERROR_MESSAGE.ENTERED_INCORRECT_OTP_3_TIMES) {
                resetPage();
                setDisableField(false);
                redirectToErrorPage('You’ve entered 3 invalid OTPs', ERROR_MESSAGE.TEMPORARILY_BLOCK_USER,'');
                OtpTagging.lastInvalidOtpEntered("You’ve entered 3 invalid OTPs","For your security, you’ve been temporarily blocked from requesting new OTPs.", "Please try again after 24 hours.");
                Constants.removeCookie(Constants.AUTH_TOKEN);
                setViewPopup('none');
                setShowOtpPopUP(false);
              } else {
                scrollToTop();
                props.showLoader(false);
                showNotificationPopup(true, ERROR_MESSAGE.TECHNICAL_ERROR);
                ErrorTagging.loginTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR);
              }
          } else {
            scrollToTop();
            showNotificationPopup(true, ERROR_MESSAGE.TECHNICAL_ERROR);
            ErrorTagging.loginTechnicalError(ERROR_MESSAGE.TECHNICAL_ERROR);

          }
        }
        );
      }
  
  const changeDisplay = () => {
    props.callFromChildPage(false);
    setDisplayPage(Constants.LOGIN);

    if(window.location.search !== null && window.location.search !== undefined){
      const urlParams = new URLSearchParams(window.location.search);

      if(urlParams.has('error') && urlParams.get('error') === "true"){
        const url = window.location.toString();
        window.location.assign(url.substring(0,url.indexOf("?")));
      }
    }
  }

  const toggleShowPassword = () => {
    setShowPassword(prevState => !prevState);
  };

  const activateField = (e) => {
    setFieldActive(prevState => ({
      ...prevState,
      [`${e.target.id}Active`]: true
    }));
  };

  const encryptEnteredPassword = (value) => {
    setPassDisplayValue(value);
  };

  return(
  
  <>
    {
      isError &&
      <ErrorPage
        setIsError={setIsError}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
      />
    }
    { displayPage === Constants.LOGIN && !props.isError && !isError &&(
      <LoginContainer>
        {
          showOtpPopUp && 
          <OtpPopUp
            code={otpCode}
            setCode={setOTPCode}
            maximumLength={Constants.MAXIMUM_CODE_LENGTH}
            setIsPinReady={setIsPinReady}
            viewPopup={viewPopup}
            setViewPopup={setViewPopup}
            setOtpSentto={setOtpSentto}
            display={notificationAlertDisplay}
            setDisplay={setNotificationAlertDisplay}
            notificationText={notificationAlertMessage}
            otpSentTo={otpSentTo}
            validateOtp={validateOtp}
            otpResendMessage={otpResendMessage}
            snackBarDisplay={snackBarDisplay}
            setSnackBarDisplay={setSnackBarDisplay}
            resendOtp={resendOtp}
          />
        }
        <BusinessLogo>
          <img width={'100%'} height={props.imageHeight} src={businessLogo} alt='LOGO' />
        </BusinessLogo>

        { showLoader && 
          <Loader/>
        }

        <>
          <TextField
            inputLabel={ 'Username' }
            placeholder={ 'Enter username' }
            isLogin={ true }
            onFocus={ activateField }
           onChange={onChange}
           value={ username }
           callForgotUsername={ callForgotUsername }
           fieldType="username"
           toggleShowPassword= { toggleShowPassword }
           forgotLink={callForgotUsername}
           isError={isWrongUsrNamePasswrd}
           disableField={disableField}
           setDisableField={setDisableField}
          />

          <TextField
            inputLabel={ 'Password' }
            placeholder={ 'Enter password' }
            isLogin={ true }
            showPassword={ false }
            onChange={onChange}
            callForgotPassword={ callForgotPassword }
            fieldType="password"
            forgotLink={callForgotPassword}
            isError={isWrongUsrNamePasswrd}
            inLineMessage={'The username or password you’ve entered is incorrect'}
            disableField={disableField}
            setDisableField={setDisableField}
          />

          <RememberMeContainer>
              <RememberMeCheckBox 
                type='checkbox'
                id='acceptTC' 
                checked={!!rememberme} 
                onChange={ (e) => { setRememberme(e.target.checked) }
              } />

            <RememberMeLabel className={rememberme && 'active'}>
              <RememberMeIcon 
                focusable='false' 
                aria-hidden='true'>
              </RememberMeIcon>
            </RememberMeLabel>

            <RememberMeText>
              Remember me
            </RememberMeText>
          </RememberMeContainer>

          <ControlContainer>
            <PrimaryButton 
              disabled={!disableLogin}
              onClick={ callOnSubmit }>
                Log in 
            </PrimaryButton>

            <RegisterText>
              Don’t have an account?

              <RegisterHyperlink
                onClick={() => setPageToBeDisplayed(Constants.REGISTER)}>
                  Register
              </RegisterHyperlink>

            </RegisterText>
          </ControlContainer>
        </>

      </LoginContainer>
      )}

      {(displayPage === Constants.ERROR || props.isError) && (
      <Error eTitle={'Sorry!'} changeDisplay={changeDisplay} />
    )}
  </>
  );
}

const mapStateToProps = state => {
  return {
    pageToBeDisplayed: state.pageToBeDisplayed,
    otpmsisdn: state.otpmsisdn
  }
};

export default withRouter(HOCLogger(connect(mapStateToProps)(LoginLayout)));
